interface DialogOptions {
    title?: string;
    message: string;
    confirmMessage?: string;
    closeMessage?: string;
}

const isOpen = ref(false);
const dialogOptions = ref<DialogOptions | null>(null);
let resolvePromise: ((value: boolean) => void) | null = null;

export function useDialog() {
    const confirm = (options: DialogOptions): Promise<boolean> => {
        return new Promise((resolve) => {
            isOpen.value = true;
            dialogOptions.value = options;
            resolvePromise = resolve;
        });
    };

    const onConfirm = () => {
        isOpen.value = false;
        resolvePromise?.(true);
    };

    const onClose = () => {
        isOpen.value = false;
        resolvePromise?.(false);
    };

    return {
        isOpen,
        dialogOptions,
        confirm,
        onConfirm,
        onClose
    };
}
